import {useMemo, useState} from 'react';
import type {GridSortModel} from '@mui/x-data-grid-pro';
import {mapSortingConfigToString} from '../mappers/mapSortingConfigToString';

/**
 * Local copy, datagrid still owns the state.
 */
export const useSort = (
  initialSortModel?: GridSortModel,
): {
  sort?: string;
  onSortModelChange: (model: GridSortModel) => void;
} => {
  const [sortModel, setSortModel] = useState<GridSortModel>(
    () => initialSortModel ?? [],
  );

  const sort = useMemo(() => {
    const [item] = sortModel;

    return item?.sort
      ? mapSortingConfigToString({field: item.field, sort: item.sort})
      : undefined;
  }, [sortModel]);

  return useMemo(() => ({sort, onSortModelChange: setSortModel}), [sort]);
};
